<template>
<div>
  <vue-headful :title="site_title" />
  <Header />
  <!-- pages widget -->
  <template v-if="this.response">
    <template v-if="this.response.ok">
      <table class="pms__wrappertable" width="100%">
        <tr>
          <!--left side -->
          <td width="24%" valign="top">
            <UserControlPanel :inbox="this.response['inbox']" :outbox="this.response['outbox']" :unsent="this.response['unsent']" />
          </td>

          <!-- empty separator -->
          <td width="1%"></td>

          <!--right side -->
          <template v-if="this.response.pm">
            <td width="75%" valign="top">
              <div class="ucp__content">
                <div class="ucp__content_header">Добро пожаловать в ваши личные данные </div>
                <div class="ucp__content_subtitle">{{htmlDecode(this.response.pm.title)}}</div>
                <div class="pm__upper_fluff">[ <a>Переадресовать сообщение</a> | <a>Ответить</a> ]</div>

                <!--{{this.response}}-->
                <div class="pm__content_wrap">
                  <div class="pm__subtitle">Сообщение</div>
                  <table class="pm__table" width="100%">
                    <!-- top line -->
                    <tr class="pm__darkbg">
                      <td class="pm__firstColumn"><b><a :href="'index.php?showuser='+this.response.pm.posterid">{{htmlDecode(this.response.pm.postername)}}</a></b></td>
                      <td class="pm__box_above_post">
                        <div style="display: flex; align-items: center;">
                          <div style="width: 60%;">
                            <b>{{htmlDecode(this.response.pm.title)}}</b>, {{this.response.pm.postdate | formatDate}}
                          </div>
                          <div style="width: 40%; text-align: right; padding-top:2px; margin-bottom: -2px;">
                            <a><img src="../assets/p_quote.gif"></a>
                          </div>
                        </div>
                      </td>
                    </tr>

                    <!-- mid line -->
                    <tr class="pm__lightbg">

                      <!-- Avatar and other info -->
                      <td class="pm__firstColumn" valign="top">
                        <template v-if="this.response.pm.avatar.length > 0 && this.response.pm.avatar.avatar !== 'noavatar'">
                          <img class="avatar" :src="fixAvatarPath(this.response.pm.avatar)" />
                        </template>
                        <br>
                        <br>
                        <!-- title -->
                        <template v-if="this.response.pm.postertitle.length> 0">{{htmlDecode(this.response.pm.postertitle)}}</template> <!-- custom title -->
                        <template v-else>{{getTitleFromPosts(this.response.pm.posterposts)}}</template> <!-- normal title -->
                        <br>
                        <!-- PIPS -->
                        <div>
                          <img v-for="n in getPipsFromPosts(this.response.pm.posterposts)" src="../assets/pip.gif" :alt="n | consumeN">
                        </div>
                        Сообщений: {{this.response.pm.posterposts | formatInt}}<br>
                        <div style="width: 165px; height: 1px;"></div>
                      </td>

                      <!-- THE POST -->
                      <td class="thread__posttext" width="100%" valign="top">
                        <div v-html="fixQuoteTags(fixVariousTags(fixRpgplanetLinks(fixSmileysPath(this.response.pm.post))))"></div>

                        <!-- Signature -->
                        <div class="thread__signature" v-if="this.response.pm.signature && this.response.pm.signature.length > 0">
                          <br><br>
                          --------------------
                          <br>
                          <div v-html="fixVariousTags(fixRpgplanetLinks(this.response.pm.signature))"></div>
                        </div>
                      </td>
                    </tr>

                    <!-- bottom line -->
                    <tr class="pm__darkbg">
                      <td class="pm__firstColumn" style="font-size:11px;">
                        <div style="padding-bottom:3px;">[ <a>Добавить в контакты</a> ]</div>
                      </td>
                      <td>
                        <div style="display: flex; align-items: center; padding: 5px; line-height: 80%;">
                          <a><img src="../assets/p_card.gif"></a> <a><img src="../assets/p_pm.gif"></a> <a><img src="../assets/p_email.gif"></a>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>

              </div>
            </td>
          </template>
          <template v-else>
            У вас нет доступа к этому сообщению.
          </template>
        </tr>
      </table>
      <FooterPermanent v-if="this.footerReady" :loadTime="this.loadTime" :totalRequests="this.response.queries" />
    </template>
    <template v-else>
      Пожалуйста перелогиньтесь.
    </template>
  </template>
</div>
</template>

<script>
import Header from './Header'
import UserControlPanel from './UserControlPanel'
import FooterPermanent from './FooterPermanent'
import {
  globalFormatDate
} from '../../public/utils.js';

export default {
  components: {
    Header,
    FooterPermanent,
    UserControlPanel,
  },
  data: function() {
    return {
      response: null,
      footerReady: false
    }
  },
  async created() {
    let dateEarly = new Date();
    let response = null;
    if (this.$route.query.MSID) {
      response = await fetch(this.getNodePath() + 'pms/get/' + this.$route.query.MSID);
      let dateLater = new Date();
      this.response = await response.json();
      this.loadTime = this.spanSeconds(dateEarly, dateLater);
      this.footerReady = true;
    }
  },
  methods: {
    fixQuoteTags(html) {
      return html.replace(/\[QUOTE\]((.|\n)*)\[\/QUOTE\]/gui, function(a, b) {
          let result = '<div class="quotetop">Цитата</div>';
          result += '<div class="quotemain">'
          result += b;
          result += '</div>';
          return result;
        })
        .replace(/\[QUOTE\]((.|\n)*)\[\/QUOTE\]/gui, function(a, b) {
          let result = '<div class="quotetop">Цитата</div>';
          result += '<div class="quotemain">'
          result += b;
          result += '</div>';
          return result;
        })
        .replace(/\[QUOTE\]((.|\n)*)\[\/QUOTE\]/gui, function(a, b) {
          let result = '<div class="quotetop">Цитата</div>';
          result += '<div class="quotemain">'
          result += b;
          result += '</div>';
          return result;
        })
        .replace(/\[QUOTE\]((.|\n)*)\[\/QUOTE\]/gui, function(a, b) {
          let result = '<div class="quotetop">Цитата</div>';
          result += '<div class="quotemain">'
          result += b;
          result += '</div>';
          return result;
        })
        .replace(/\[QUOTE\]((.|\n)*)\[\/QUOTE\]/gui, function(a, b) {
          let result = '<div class="quotetop">Цитата</div>';
          result += '<div class="quotemain">'
          result += b;
          result += '</div>';
          return result;
        });
    },
  },
  filters: {
    consumeN: function(number) {
      return "*";
    }
  }
}
</script>

<style lang="scss">
@import "./PMs.scss";
@import "./Thread.scss";

.pm__upper_fluff {
    color: #d8d8d8;
    text-align: right;
    padding: 2px;
}

.pm__content_wrap {
    margin: 5px;
    background: #546971;
    border: 1px solid #000;
}

.pm__subtitle {
    background: transparent url("../assets/tile_sub.gif");
    border-bottom: 1px solid #000;
    color: #fff;
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    margin: 0;
    padding: 5px;
}

.pm__darkbg {
    background: #1E2C38;
}

.pm__lightbg {
    background: #273643;
}

.pm__table {
    //border: 1px solid !important;
    td,
    th,
    tr {
        border: 1px solid #546971 !important;
    }
}
.pm__firstColumn {
    color: #d8d8d8;
    padding: 5px;
}
.pm__box_above_post {
    padding: 2px 5px;
    color: #d8d8d8;
}
</style>
